import { useMemo } from 'react';

import useActions from '../../../../hooks/useActions';
import { logAnalyticsEvent } from '../../../../redux/actions/analyticsLog';
import { makeProductByIdSelector } from '../../../../redux/selectors/productById';
import { makeDefaultCurrencyData } from '../../../../redux/selectors/VBConfigSelector';
import { useSelector } from '../../../../redux/utils';
import routeUtils from '../../../../utils/routes';
import { showNumberWithComma } from '../../../../utils/stringHelper';

export const useReduxHooks = ({ id }) => {
  const item = useSelector(makeProductByIdSelector(id));
  const logEvent = useActions(logAnalyticsEvent);

  return { item, logEvent };
};

export const usePriceText = (price, originalPrice) => {
  const { symbol } = useSelector(makeDefaultCurrencyData());
  const originPriceText = useMemo(() => {
    const parsedPrice = showNumberWithComma(Math.abs(Number(originalPrice)));

    return `${symbol} ${parsedPrice}`;
  }, [originalPrice, symbol]);

  const currentPriceText = useMemo(() => {
    const parsedPrice = showNumberWithComma(Math.abs(Number(price)));

    return `$${parsedPrice}`;
  }, [price]);

  return { originPriceText, currentPriceText };
};

export const useWebHref = ({ id }) => {
  return useMemo(() => {
    const pathInfo = routeUtils.getPathAndParamsFromData('ItemPage', {
      id,
    });

    return pathInfo.fullPath;
  }, [id]);
};
